import type { ReactElement } from "react"

import { TextBodyText } from "@/components/design-system/Text/TextBodyText"

import type { ErrorPageProps } from "./ErrorPage"
import { ErrorPage } from "./ErrorPage"

export function AccessDeniedPage({
  title = "Access Denied",
  subtitle = (
    <TextBodyText type="error" className="ErrorPage__card-subtitle">
      You do not have permission to access this page with your account. Please contact
      your admin for further assistance.
    </TextBodyText>
  ),
  ...rest
}: Partial<ErrorPageProps>): ReactElement {
  return <ErrorPage title={title} subtitle={subtitle} {...rest} />
}
